import React from "react";
import ErrorCustom from "./errorCustom";
import IconAdd from "../Resources/svg/Icons/IconAdd";
import IconRemove from "../Resources/svg/Icons/IconRemove";

const YearComponents = ({errors, comboValidator, register, selectYEar}) => {
  return (
    <div className="boxCounter__boxes">
      <div className="boxCounter__boxes__wapper" id="box_decrement">
        <IconRemove color={"#A9AFD9"} />
      </div>
      <div>
        <select
          id="yearTemp"
          name="yearTemp"
          ref={register({ validate: comboValidator })}
          disabled={true}
          className="boxCounter__boxes__select"
        >
          {selectYEar.map((item, index) => (
            <option value={item.value} key={index}>
              {item.text}
            </option>
          ))}
        </select>
        <ErrorCustom errors={errors} name="yearTemp" />
      </div>
      <div className="boxCounter__boxes__wapper" id="box_increment">
        <IconAdd color={"#A9AFD9"} />
      </div>
    </div>
  );
};

export default YearComponents;
